import {
  AfterViewInit,
  Directive,
  ElementRef,
  HostListener,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Renderer2,
  SimpleChanges
} from '@angular/core';
import {AppService} from 'src/app/app.service';
import {ResizeSensor} from 'css-element-queries';
import {Constants} from '../utils/constants';
import {Broadcaster} from '../../app.broadcast';
import {DecimalPipe} from '@angular/common';

declare var $: any;

@Directive({
  // tslint:disable-next-line:directive-selector
  selector: '[freeze-table]',
})
export class FreezeTableDirective implements AfterViewInit {
  @Input() id: string;
  constructor(private el: ElementRef) {}

  ngAfterViewInit(): void {}

  run(callback?: any) {
    const table = this.id
      ? document.getElementById(this.id)
      : $(this.el.nativeElement);
    const maxHeight = $(table).attr('height');
    if (maxHeight) {
      $(table).css({ 'max-height': maxHeight + 'px', 'overflow-x': 'auto' });
    }
    $.each($(table).find('th'), function() {
      const w = $(this).outerWidth();
      $(this).css({ width: w + 'px' });
    });
    setTimeout(() => {
      $(table).freezeTable({
        container: '.tab-content',
        scrollable: true,
        freezeColumn: false,
        scrollBarHeight: 3,
      });
      setTimeout(() => {
        $('.clone-head-table-wrap').css({
          position: 'absolute',
        });
      });
    });
    if (callback) {
      callback();
    }
  }
}

@Directive({
  // tslint:disable-next-line:directive-selector
  selector: '[edit-permission]',
})
export class EditPermissionDirective implements AfterViewInit {
  constructor(private el: ElementRef, private appService: AppService) {}

  ngAfterViewInit(): void {
    const permission = this.appService.getCurrentPermission();
    if (!permission.allowUpdating) {
      this.el.nativeElement.remove();
    }
  }
}

@Directive({
  // tslint:disable-next-line:directive-selector
  selector: '[create-permission]',
})
export class CreatePermissionDirective implements AfterViewInit {
  constructor(private el: ElementRef, private appService: AppService) {}

  ngAfterViewInit(): void {
    const permission = this.appService.getCurrentPermission();
    if (!permission.allowCreating) {
      this.el.nativeElement.remove();
    }
  }
}

@Directive({
  // tslint:disable-next-line:directive-selector
  selector: '[delete-permission]',
})
export class DeletePermissionDirective implements AfterViewInit {
  constructor(private el: ElementRef, private appService: AppService) {}

  ngAfterViewInit(): void {
    const permission = this.appService.getCurrentPermission();
    if (!permission.allowDeleting) {
      this.el.nativeElement.remove();
    }
  }
}

@Directive({
  // tslint:disable-next-line:directive-selector
  selector: '[fx-resize]',
})
export class ResizeDirective implements AfterViewInit {
  @Input('fx-resize') sizeInfo: any;
  constructor(private el: ElementRef) {}

  ngAfterViewInit(): void {
    const resizeObj = this.el.nativeElement.querySelector('.resize');
    const heightObj = this.el.nativeElement.querySelector('.height');
    // tslint:disable-next-line:no-unused-expression
    new ResizeSensor(this.el.nativeElement, (e: any) => {
      const timeout = this.sizeInfo ? this.sizeInfo.timeout || 0 : 0;
      setTimeout(() => {
        const wrapperHeight = $(this.el.nativeElement).height();
        let h = wrapperHeight - $(heightObj).height();
        if (this.sizeInfo && this.sizeInfo.max && h > this.sizeInfo.max) {
          h = this.sizeInfo.max;
        }
        $(resizeObj).css({ height: h + 'px' });
      }, timeout);
    });
  }
}

@Directive({
  // tslint:disable-next-line:directive-selector
  selector: '[fx-copy]',
})
export class CopyDirective {
  @Input('fx-copy') text: string;
  @HostListener('click', ['$event']) onClick($event: Event): void {
    const ele = document.createElement('textarea');
    document.body.appendChild(ele);
    ele.value = this.text;
    ele.select();
    document.execCommand('copy');
    document.body.removeChild(ele);
    this.appService.showSuccess('Copy success');
  }
  constructor(private el: ElementRef, private appService: AppService) {}
}

@Directive({
  // tslint:disable-next-line:directive-selector
  selector: '[labelGroup]',
})
export class LabelGroupDirective implements OnInit {
  @Input('labelGroup') text: string;
  labelMT4Group = Constants.LABEL_MT4_GROUP;
  listGroup = Object.keys(this.labelMT4Group);
  constructor(private el: ElementRef, private renderer: Renderer2) {
  }
  ngOnInit(): void {
    // const text = (this.listGroup.includes(this.text))
    //   ? this.labelMT4Group[this.text]
    //   : this.text;
    const text = this.text;
    this.renderer.setProperty(this.el.nativeElement, 'innerHTML', text);
  }
}

@Directive({
  // tslint:disable-next-line:directive-selector
  selector: '[labelNumber]',
})
export class LabelNumberDirective implements OnInit, OnChanges {
  @Input('labelNumber') value: any;
  @Input() currency: string;
  @Input() emo = '';
  formatNumber = Constants.FIXED_NUMBER;
  symbol = Constants.SYMBOL_CURRENCY;
  constructor(private el: ElementRef,
              private renderer: Renderer2,
              private fxNumber: DecimalPipe) {
  }
  ngOnChanges(change: SimpleChanges): void {
    if (change.value && change.value.currentValue) {
      this.onfill();
    }
  }
  ngOnInit(): void {
    this.onfill();
  }
  private onfill(): void {
    let value = this.fxNumber.transform(
      +(this.value),
      this.formatNumber[this.currency]
    );
    if (this.emo) {
      value = this.symbol[this.currency] + ' ' + value;
    }
    this.renderer.setProperty(this.el.nativeElement, 'innerHTML', value);
  }
}

@Directive({
  // tslint:disable-next-line:directive-selector
  selector: '[doubleClick]'
})
export class DoubleClickDirective implements OnInit, OnDestroy, OnChanges {
  // @Output()
  // doubleClick = new EventEmitter();
  @Input('doubleClick') item;
  @Input() normalClick;
  @Input() timeClick = 3000;
  sub: any;

  constructor(
    private broadcast: Broadcaster,
    private el: ElementRef) {
  }

  @HostListener('click', ['$event'])
  clickEvent(event): void {
    if (this.normalClick) {
      this.sub.unsubscribe();
      event.stopPropagation();
      event.preventDefault();
      this.el.nativeElement.classList.add('button-loading');
      this.sub = setTimeout(() => {
        // event.srcElement.removeAttribute('disabled');
        this.el.nativeElement.classList.remove('button-loading');
      }, this.timeClick);
    }
    // event.srcElement.setAttribute('disabled', true);
    // event.srcElement.setAttribute('style', 'pointer-events: none;');
  }

  ngOnChanges(change: SimpleChanges): void {
    if (change.item.currentValue) {
      this.el.nativeElement.classList.add('button-loading');
    }
  }

  ngOnInit(): void {
    this.sub = this.broadcast.on('CLOSE_DOUBLE_CLICK').subscribe((url: string) => {
      if (url.indexOf('/api/') > 0) {
        const pathAPi = new URL(url).pathname;
        if (Constants.API_DOUBLE_CLICK.includes(pathAPi)) {
          this.el.nativeElement.classList.remove('button-loading');
        }
      }
    });
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }
}

@Directive({
  selector: '[roxDebounceClick]'
})
export class DebounceClickDirective {
  @Input('roxDebounceClick') debounceTime = 1000;
  constructor(private elementRef: ElementRef, private renderer: Renderer2) { }
  @HostListener('click', ['$event'])
  clickEvent(): void{
    this.renderer.addClass(this.elementRef.nativeElement, 'disable-click');
    setTimeout(() => {
      this.renderer.removeClass(this.elementRef.nativeElement, 'disable-click');
    }, this.debounceTime);
  }
}

@Directive({selector: '[numberOnly]'})
export class NumberOnlyDirective {
  constructor(private el: ElementRef) { }

  @HostListener('input', ['$event']) onInputChange(event): void {
    const initialValue = this.el.nativeElement.value;
    this.el.nativeElement.value = initialValue.replace(/[^0-9]*/g, '');
    if (initialValue !== this.el.nativeElement.value) {
      event.stopPropagation();
    }
  }
  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent): void {
    event.preventDefault();
  }
}
import { AbstractControl, NG_VALIDATORS, Validator, ValidationErrors } from '@angular/forms';

@Directive({
  selector: '[trimValidator]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: TrimValidatorDirective,
      multi: true
    }
  ]
})
//custom trímspace
export class TrimValidatorDirective implements Validator {
  @Input('trimValidator') trimOnSubmit: boolean = true;

  validate(control: AbstractControl): ValidationErrors | null {
    if (!this.trimOnSubmit) {
      return null; // Nếu không trim giá trị, bỏ qua validator này.
    }
    // Trim đầu chuỗi.
    const trimStartValue = control.value?.trimStart();
    // Kiểm tra nếu giá trị đã được trim, nếu không thì trả về lỗi required.
    return control.value === trimStartValue ? null : { required: true };
  }
}
